import React, { useState, forwardRef, useRef, useCallback, useImperativeHandle } from 'react';
import {
  Box,
} from "@mui/material";
import styles from "../../entity-editor/EntityEditor.styles";
import StyledTextField from "../../styled-components/StyledTextField";
import PostcodeForm, { PostcodeFormHandle } from '../../postcode-form/PostcodeForm';
import ValidatedAccordion from './ValidatedAccordion';
import CityAutocomplete from '../../city-autocomplete/CityAutocomplete';
import { LatinTextField } from '../../latin-text-field/LatinTextField';
import { NumericTextField } from '../../numeric-text-field/NumericTextField';

export type ObjectAddressBlockHandle = {
  reset: () => void;
}

interface ObjectAddressBlockProps {
  onChange?: any,
  objectFields?: any,
  errors?: any,
  selectAddressObject?: any,
  unitsLength?: number,
  setErrors?: any,
}

const ObjectAddressBlock = forwardRef<ObjectAddressBlockHandle, ObjectAddressBlockProps>(({
  onChange,
  objectFields,
  errors,
  selectAddressObject,
  unitsLength,
  setErrors,
}, ref) => {
  const type = "object";
  const [expanded, setExpanded] = useState<null | "object_address">(null);
  const [inputValueObjectCity, setInputValueObjectCity ] = useState("");
  const postcodeRef = useRef<PostcodeFormHandle | null>(null);

  const reset = useCallback(() => {
    setInputValueObjectCity("");
    postcodeRef.current?.reset();
  }, []);
  useImperativeHandle(ref, () => ({reset}), [reset]);

  return (
    <ValidatedAccordion
      title="Address *"
      hasErrors={!errors.isFilledCity}
      expanded={expanded === "object_address"}
      onChange={(isExp) => setExpanded(isExp ? "object_address" : null)}
    >
        <PostcodeForm
          ref={postcodeRef}
          type={type}
          selectAddress={selectAddressObject}
          address={objectFields}
        />
        <Box sx={styles.fieldHolder}>
          <Box sx={styles.fieldBlock}>
            <CityAutocomplete
              label="City"
              name="city_name"
              value={objectFields?.address?.city_name}
              inputValue={inputValueObjectCity}
              setInputValue={setInputValueObjectCity}
              minChars={3}
              debounceMs={300}
              errorFields={!errors.isFilledCity}
              setErrorFields={setErrors}
              textFieldProps={{
                fullWidth: true,
                margin: "dense",
                type: "text",
                required: true,
              }}
              onChange={(e) => onChange("objectAddress", "city_name", e, -1)}
            />
            <LatinTextField
              fullWidth
              label="Street"
              type="text"
              name="street_name"
              // errorFields={errorAddressFields.street_name}
              // setErrorFields={setErrorAddressFields}
              margin="dense"
              value={objectFields?.address?.street_name}
              onChange={(e) =>
                onChange("objectAddress", "street_name", e, -1)
              }
              disabled={(unitsLength ?? 0) > 0}
            />
            <NumericTextField
              fullWidth
              label="Number"
              type="text"
              name="number"
              // errorFields={errorAddressFields.number}
              // setErrorFields={setErrorAddressFields}
              margin="dense"
              value={objectFields?.address?.number}
              onChange={(e) => onChange("objectAddress", "number", e, -1)}
              disabled={(unitsLength ?? 0) > 0}
            />
          </Box>
          <Box sx={styles.fieldBlock}>
            <StyledTextField
              fullWidth
              label="Number add"
              margin="dense"
              onChange={(e) => onChange("objectAddress", "number_add", e, -1)}
              value={objectFields?.address?.number_add}
              disabled={(unitsLength ?? 0) > 0}
            />
            <StyledTextField
              fullWidth
              label="Postcode"
              margin="dense"
              onChange={(e) => onChange("objectAddress", "postcode", e, -1)}
              value={objectFields?.address?.postcode}
              disabled={(unitsLength ?? 0) > 0}
            />
          </Box>
        </Box>
    </ValidatedAccordion>
  );
});

export default ObjectAddressBlock;
